import React from 'react';
import {
  Button,
  Grid,
  Paper,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import { Radio } from 'final-form-material-ui';
import { Field } from 'react-final-form';
import required from '../validators/required';
import Condition from '../utilities/Condition';

const PaymentDetails = ({ submitting, invalid, pristine, attendeeCount, total }) => (
  <Paper style={{ padding: 16, marginTop: 16 }}>
    <Grid container alignItems="flex-start" spacing={8}>
      <Grid item xs={12}>
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Payment</FormLabel>
          {!!(attendeeCount && total) ?
            <Typography variant="body1" style={{ paddingBottom: 10 }}>Total for {attendeeCount} attendee{attendeeCount > 1 ? 's' : ''}:
            ${total} (excl GST<Condition when="PaymentMethod" is="CreditCard"> and surcharge</Condition>)</Typography> :
            <Typography variant="body1" style={{ paddingBottom: 10 }}>Pricing will update as the form is filled in</Typography>}
          <Typography variant="body1" style={{ paddingBottom: 10 }}>Upon completion of registration, an invoice will be sent via email with payment options included.</Typography>
          <Typography variant="body1" style={{ paddingBottom: 10 }}>Payment by credit card can be accepted over the phone and will incur a 3% surcharge.</Typography>
          <RadioGroup>
            <FormControlLabel
              label="I have read and accept the cancellation policy."
              control={
                <Field
                  name="PaymentMethod"
                  component={Radio}
                  type="radio"
                  value="Invoice"
                  validate={required}
                />
              }/>
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
      </Grid>
      <Grid item style={{ marginTop: 16 }}>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={submitting || invalid || pristine}
        >
          Register
        </Button>
      </Grid>
    </Grid>
  </Paper>
);

export default PaymentDetails;
